export default __webpack_public_path__ + "static/media/6.a5f51816.png";